export const ClaimFormData = () => {

    return {
        formDetails :{
            mail_form_to: "",
            requester_name: "",
            requester_email: "",
            sro_manager: "",
            customer_id: null,
            customer_name: "",
            sold_to_no: null,
            ship_to_no: null,
            original_invoice_no: "",
            sales_order: "",
            reference: "",
            invoice_date: "",
            invoice_currency: "",
            shipment_no: "",
            delivery_from_packing_list: "",
            claimFormPartDetails:[],
            remarks:""
        },
        partRecord:{
            part_number: "",
            quantity: null,
            price:null,
            total:null,
            reason: ""
        },
        validationRules:{
            requester_name: { required: true },
            requester_email: { required: true },
            reference: { required: true },
            original_invoice_no:{ required: true },
            sales_order:{ required: true },
            invoice_date: { required: true },
            shipment_no:{ required: true }
        },
        validatePartRules : {
            part_number:{ required: true }
        }
    }
}
